/** SPECIFICATION.md clause 1.4 — key constants. */

/** Default perpend joint for a new wall, in millimetres. */
export const DEFAULT_PERPEND_GAP_MM = 10.0;
/** Bed joint between courses. Fixed; never user-editable (clause 4.1). */
export const BED_JOINT_GAP_MM = 10.0;
/** Upper bound on the perpend joint. */
export const MAX_PERPEND_GAP_MM = 10_000.0;
/**
 * All world coordinates are multiples of this. An eighth of a millimetre
 * exactly represents the centre of a 46.25 mm quarter bat (clause 2.2).
 */
export const COORDINATE_QUANTUM_MM = 0.125;
/** Snap radius in screen pixels (clause 6.1). Consumed by the renderer. */
export const SNAP_TOLERANCE_PX = 15.0;
/** Cap on the pixel snap radius once converted to millimetres (clause 6.1). */
export const MAX_SNAP_TOLERANCE_MM = 500.0;
/** Float comparison tolerance throughout. */
export const EPSILON = 1e-9;
/** Uniform grid cell for the spatial index — slightly larger than a block. */
export const SPATIAL_CELL_SIZE_MM = 500.0;

/** Export sizing (clause 14.5). */
export const EXPORT_MARGIN_MM = 20.0;
export const EXPORT_PIXELS_PER_MM = 2.0;
export const EXPORT_MAX_DIMENSION_PX = 5000;
export const EXPORT_MAX_PIXELS = 16_000_000;
